<template>
	<div class="input-errors" v-for="error of errors" :key="error.$uid">
		<div class="invalid-feedback d-block">{{ error.$message }}</div>
	</div>
</template>
<script>
export default {
	props: {
		errors: Array
	}
}
</script>